"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.function.bind");

var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInput = _interopRequireDefault(require("@nerdwallet/react-input"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @constant - array of date field objects
 * @property {string} name - The name of the date field.
 * @property {number} length - The max length the date field value can have.
 * @property {string} next - The next date field to focus when current field value reaches max length.
 * @property {string} prev - The previous date field to focus when current field value reaches 0.
 */
var DATE_FIELDS = [{
  name: 'month',
  length: 2,
  next: 'day'
}, {
  name: 'day',
  length: 2,
  next: 'year',
  prev: 'month'
}, {
  name: 'year',
  length: 4,
  prev: 'day'
}];

var SplitDateInput = /*#__PURE__*/function (_Component) {
  _inherits(SplitDateInput, _Component);

  var _super = _createSuper(SplitDateInput);

  function SplitDateInput(props) {
    var _this;

    _classCallCheck(this, SplitDateInput);

    _this = _super.call(this, props);
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    /**
     * Input dom elements obtained via refs
     */

    _this.inputs = {};
    /**
     * State is used to display month, day, year and complete date values for the inputs.
     * Although there is internal state, this is a controlled component because when we receive the prop "value" we parse it into the state.
     * State is just used as an intermediate to construct the full date string we then pass to this.props.onChange.
     * In future this should be changed as it's an antipattern to the framework.
     */

    _this.state = {
      date: props.value,
      day: '',
      month: '',
      year: ''
    };
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  _createClass(SplitDateInput, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Parse props on initial render
      this.updateStateFromProps(this.props);
    } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Parse props on prop changes
      this.updateStateFromProps(nextProps);
    }
  }, {
    key: "onChange",
    value: function onChange(field, e) {
      var _this2 = this;

      var dateField = (0, _find2["default"])(DATE_FIELDS, {
        name: field
      });
      var prevValue = (0, _get2["default"])(this.state, dateField.name);
      var value = e.target.value; // Ignore if value hasn't changed or user inputed a non digit

      if (this.state[field] === value || (0, _isNaN2["default"])(value)) {
        return;
      } // Get the new state and construct date string from it


      var newState = _objectSpread(_objectSpread({}, this.state), {}, _defineProperty({}, field, value));

      var focusField = field;

      if (value.length > dateField.length) {
        // Typing in an already full field should move new digit to next field
        // If no next field, do nothing
        if (!dateField.next) {
          return;
        }

        focusField = dateField.next;
        newState = _objectSpread(_objectSpread({}, this.state), {}, _defineProperty({}, dateField.next, value.substring(value.length - 1)));
      } else if (value.length === dateField.length && dateField.next) {
        // Move focus to next field if current field is now full
        focusField = dateField.next;
      } else if (prevValue.length > 0 && value.length === 0 && dateField.prev) {
        // Move focus to previous field if current field is now empty
        focusField = dateField.prev;
      }

      this.setState(_objectSpread(_objectSpread({}, newState), {}, {
        date: "".concat(newState.month, "/").concat(newState.day, "/").concat(newState.year)
      }), function () {
        _this2.focus(focusField);

        _this2.props.onChange(_this2.state.date);
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      e.preventDefault();
      this.props.onBlur(this.state.date);
    }
  }, {
    key: "focus",
    value: function focus(field) {
      var domNode = this.inputs[field];
      domNode.focus();
    }
  }, {
    key: "updateStateFromProps",
    value: function updateStateFromProps(props) {
      // Parse the prop "value" into three separate date fields
      var fieldValues = props.value.split('/');
      var newState = {
        month: fieldValues[0] || '',
        day: fieldValues[1] || '',
        year: fieldValues[2] || ''
      };
      var date = "".concat(newState.month, "/").concat(newState.day, "/").concat(newState.year);
      this.setState(_objectSpread(_objectSpread({}, newState), {}, {
        date: date
      }));
    }
    /* eslint-disable react/jsx-no-bind */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classes["default"])('display-flex')
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactInput["default"], {
        inputRef: function inputRef(input) {
          _this3.inputs.month = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'month'),
        value: this.state.month,
        placeholder: "MM"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactInput["default"], {
        inputRef: function inputRef(input) {
          _this3.inputs.day = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'day'),
        value: this.state.day,
        placeholder: "DD"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactInput["default"], {
        inputRef: function inputRef(input) {
          _this3.inputs.year = input;
        },
        error: this.props.error,
        onChange: this.onChange.bind(null, 'year'),
        onBlur: this.onBlur,
        value: this.state.year,
        placeholder: "YYYY"
      })));
    }
    /* eslint-enable react/jsx-no-bind */

  }]);

  return SplitDateInput;
}(_react.Component);

exports["default"] = SplitDateInput;

_defineProperty(SplitDateInput, "displayName", 'SplitDateInput');

_defineProperty(SplitDateInput, "propTypes", {
  value: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
});

_defineProperty(SplitDateInput, "defaultProps", {
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  error: false
});